import React from 'react'
import { IconProps } from '../../../common/types'

const Hamburger: React.FC<IconProps> = () => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 12C2.47778 12 2.31956 11.936 2.192 11.808C2.06445 11.68 2.00045 11.5218 2 11.3333C1.99956 11.1449 2.06356 10.9867 2.192 10.8587C2.32045 10.7307 2.47867 10.6667 2.66667 10.6667H13.3333C13.5222 10.6667 13.6807 10.7307 13.8087 10.8587C13.9367 10.9867 14.0004 11.1449 14 11.3333C13.9996 11.5218 13.9356 11.6802 13.808 11.8087C13.6804 11.9371 13.5222 12.0009 13.3333 12H2.66667ZM2.66667 8.66667C2.47778 8.66667 2.31956 8.60267 2.192 8.47467C2.06445 8.34667 2.00045 8.18844 2 8C1.99956 7.81156 2.06356 7.65333 2.192 7.52533C2.32045 7.39733 2.47867 7.33333 2.66667 7.33333H13.3333C13.5222 7.33333 13.6807 7.39733 13.8087 7.52533C13.9367 7.65333 14.0004 7.81156 14 8C13.9996 8.18844 13.9356 8.34689 13.808 8.47533C13.6804 8.60378 13.5222 8.66756 13.3333 8.66667H2.66667ZM2.66667 5.33333C2.47778 5.33333 2.31956 5.26933 2.192 5.14133C2.06445 5.01333 2.00045 4.85511 2 4.66667C1.99956 4.47822 2.06356 4.32 2.192 4.192C2.32045 4.064 2.47867 4 2.66667 4H13.3333C13.5222 4 13.6807 4.064 13.8087 4.192C13.9367 4.32 14.0004 4.47822 14 4.66667C13.9996 4.85511 13.9356 5.01356 13.808 5.142C13.6804 5.27044 13.5222 5.33422 13.3333 5.33333H2.66667Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Hamburger
